<template>
    <toolbar-option type="stacked">
        <template slot="secondary">
            <color-picker
                :value="color"
                @input="onColorInput"
            />
        </template>

        <template slot="primary">
            <slider
                :value="sliderIndex"
                :values="textShadowValues"
                @input="onSliderInput"
            />
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option';

const DEFAULT_SHADOW_COLOR = '#000000';

export default {
    name: 'text-shadow',
    mixins: [baseOption],

    data() {
        return {
            displayName: 'Text Shadow',
            sliderIndex: 0,
            blurValue: '0px',
            color: DEFAULT_SHADOW_COLOR,
            cssString: '',
            selected: '',
            textShadowValues: [
                '0px',
                '1px',
                '2px',
                '3px',
                '4px',
                '5px',
                '6px',
                '7px',
                '8px',
                '9px',
                '10px',
            ],
        };
    },

    methods: {
        onColorInput(newColor) {
            this.color = newColor;
            this.generateCssString();
        },

        onSliderInput(newIndex) {
            this.sliderIndex = newIndex;
            this.blurValue = this.textShadowValues[newIndex];
            this.generateCssString();
        },

        onSelectedElement() {
            if (this.selectedElements[0].hasElementData('text-shadow')) {
                const textShadow = this.selectedElements[0].getElementData('text-shadow');
                const textShadowArr = textShadow.split(' ');

                this.blurValue = textShadowArr[2];
                this.color = textShadowArr[3];
                this.sliderIndex = this.textShadowValues.indexOf(this.blurValue);
            } else {
                this.sliderIndex = 0;
                this.color = DEFAULT_SHADOW_COLOR;
            }
        },

        generateCssString() {
            this.cssString = `0 0 ${ this.blurValue } ${ this.color }`;

            this.selectedElements.forEach((selectedElem) => {
                selectedElem.setElementData('text-shadow', this.cssString);
            });

            this.onOptionChange(this.cssString);
        },
    },
};
</script>
